import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const OutletContainer = styled.div`
  height: 100%;
  overflow-y: auto;
`;
